<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <div>
      <b-card-body>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Pricing List</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>

        <div>
          <div>
            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row class="align-items-end">
                <b-col md="4">
                  <label for="blType">Date</label>
                  <date-range-picker
                    :opens="openRight"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    @update="debounceSearch"
                  ></date-range-picker>
                </b-col>
                <b-col md="2"
                  ><label for="pendingStatus">Status</label>
                  <model-list-select
                    :list="pendingStatusList"
                    id="pendingStatus"
                    v-model="Filter.pendingStatus"
                    option-value="val"
                    option-text="type"
                    placeholder="Select Status"
                    @input="debounceSearch"
                  ></model-list-select
                ></b-col>
                <b-col md="2"
                  ><label for="hours">Hours</label>
                  <model-list-select
                    :list="hoursStatusList"
                    id="hours"
                    v-model="Filter.hours"
                    option-value="val"
                    option-text="type"
                    placeholder="Select Hours"
                    @input="
                      debounceSearch();
                      getCurrentLastDate();
                      getTimeHours();
                    "
                  ></model-list-select
                ></b-col>
                <b-col md="2">
                  <label>Start Time</label>
                  <!-- {{Filter.startTime}}<br/>{{Filter.endTime}} -->
                  <b-form-input
                    :disabled="startDate ? false : true"
                    type="time"
                    @input="debounceSearch"
                    v-model="Filter.startTime"
                    locale="en"
                  ></b-form-input>
                </b-col>
                <b-col md="2">
                  <label>End Time</label>
                  <b-form-input
                    :disabled="endDate ? false : true"
                    type="time"
                    @input="debounceSearch"
                    v-model="Filter.endTime"
                    locale="en"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="Filter.branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="debounceSearch"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Created By</label>
                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllUserList']"
                    id="createdByFilter"
                    @input="debounceSearch"
                    v-model="Filter.createdByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Updated By</label>
                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllUserList']"
                    id="updatedByFilter"
                    @input="debounceSearch"
                    v-model="Filter.updatedByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Updated User"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Client Name</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="Filter.clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3"
                  ><label for="clientId">Transhipment</label>
                  <model-list-select
                    :list="StatusTypeList"
                    id="StatusType"
                    v-model="Filter.StatusType"
                    option-value="val"
                    option-text="type"
                    placeholder="Select Type"
                    @input="debounceSearch"
                  ></model-list-select
                ></b-col>
                <b-col md="3">
                  <label for="clientId">Shipment Type</label>
                  <model-list-select
                    :list="shipmentTypeList"
                    id="shipment_type"
                    v-model="Filter.shipment_type"
                    option-value="value"
                    option-text="text"
                    placeholder="Select Shipment Type"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Container Type</label>
                  <model-list-select
                    :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="Filter.ContainerTypeFilter"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="Filter.shipment_type == 'Sea'">
                  <label>POD</label>
                  <model-list-select
                    :list="$store.getters['common/getAllPODList']"
                    v-model="Filter.fk_pod_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POD"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="Filter.shipment_type == 'Sea'">
                  <label>POR</label>
                  <model-list-select
                    :list="$store.getters['common/getAllPORList']"
                    v-model="Filter.fk_por_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="Filter.shipment_type == 'Sea'">
                  <label>POL</label>
                  <model-list-select
                    :list="$store.getters['common/getAllPOLList']"
                    v-model="Filter.fk_pol_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="Filter.shipment_type == 'Sea'">
                  <label>FPOD</label>
                  <model-list-select
                    :list="$store.getters['common/getAllLocationDetailsFinalList']"
                    v-model="Filter.fk_fpod_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select FPOD"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="Filter.shipment_type == 'Sea'">
                  <label>SLine</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.fk_shipping_id"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>

                <b-col md="3" v-if="Filter.shipment_type == 'Air'">
                  <label>Airport of Destination</label>
                  <model-list-select
                    :list="$store.getters['common/getAllAirPortDestinationList']"
                    v-model="Filter.fk_airportDestination_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Airport of Destination"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="Filter.shipment_type == 'Air'">
                  <label>Air Line</label>
                  <model-list-select
                    :list="$store.getters['common/getAllAirLineList']"
                    v-model="Filter.fk_airline_id"
                    option-value="airlineId"
                    option-text="airlineName"
                    placeholder="Select Air Line"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="8">
                  <label for="clientId">Common Filter</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    @input="debounceSearch"
                    v-model="Filter.common"
                    placeholder="Type to Search Lead Master and Code"
                    ref="search"
                  />
                </b-col>
                
                <b-col md="3">
                  <div style="margin-top:35px;">
                    <!-- <b-button
                      v-if="
                        $sessionsStorage.get('designation') == 'Admin' &&
                        $sessionsStorage.get('nameUser') == 'Bhavneesh'
                      "
                      size="sm"
                      class="ml-1"
                      @click="getReports('Price_Quotation_Master_List')"
                      variant="outline-info"
                      >Export</b-button
                    > -->
                    <b-button
                      v-if="
                        $sessionsStorage.get('designation') == 'Admin' &&
                        $sessionsStorage.get('nameUser') == 'Bhavneesh'
                      "
                      size="sm"
                      class="ml-1"
                      :disabled="ExcelBtnName != 'Export' ? true : false"
                      @click="getReports('Price_Quotation_Master_List', 'Export')"
                      variant="outline-info"
                    > {{ ExcelBtnName }}
                    <b-spinner
                      v-if="ExcelBtnName != 'Export'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>
                  <b-button
                    size="sm"
                    class="ml-1"
                    variant="outline-danger"
                    @click="filterClear"
                    >Clear</b-button
                  >
                  <!-- <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button> -->
                  </div>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <h5 class="text-muted pull-right mt-2 ml-3">
                <small v-if="isLoading == false">{{ totalRows }} Entries</small>
              </h5>
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="PricingQuotList"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                  responsive
                  primary-key="price_id"
                  class="position-relative"
                >
                  <template slot="price_id" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="enq_no" slot-scope="row1">
                    <span v-if="row1.item.shipment_type">
                      Shipment Type : {{ row1.item.shipment_type }}
                      <br />
                    </span>
                    <span v-if="row1.item.transport_type">
                      Trasport Type : {{ row1.item.transport_type }}
                      <br />
                    </span>
                    <u
                      v-if="row1.item.enq_no"
                      variant="outline-primary"
                      style="font-size: 1rem; color: blue"
                      @click="editPricing(row1.item)"
                      size="sm"
                      ><b>{{ row1.item.enq_no }}</b></u
                    ><br />
                    <span v-if="row1.item.RaisedFrom"
                      >Raised From : {{ row1.item.RaisedFrom }}</span
                    >
                  </template>
                  <template slot="ShippingLine" slot-scope="row1">
                    <span v-if="row1.item.shipment_type == 'Sea'">
                      {{ row1.item.ShippingLine }}</span
                    >
                    <span v-if="row1.item.shipment_type == 'Air'">
                      {{ row1.item.airlineName }}</span
                    >
                  </template>
                  <template slot="POD" slot-scope="row2">
                    <span v-if="row2.item.shipment_type == 'Sea'">
                      {{ row2.item.POD }}</span
                    >
                    <span v-if="row2.item.shipment_type == 'Air'">{{
                      row2.item.ARDestination
                    }}</span>
                  </template>
                  <template slot="currencyCode" slot-scope="row2">
                    <span v-if="row2.item.buyingRate"
                      >Buying Rate : {{ row2.item.buyingRate }}</span
                    >
                    <span v-if="row2.item.unitName">Unit : {{ row2.item.unitName }}</span>
                    <span v-if="row2.item.currencyCode"
                      >Currency : {{ row2.item.currencyCode }}</span
                    >
                  </template>

                  <template slot="containerType" slot-scope="row4">
                    <span v-if="row4.item.shipment_type == 'Sea'"
                      >Container Type : {{ row4.item.containerType }}</span
                    >
                    <span v-if="row4.item.noOfPkg && row4.item.shipment_type == 'Air'"
                      >No. of Packages : {{ row4.item.noOfPkg }}<br
                    /></span>
                    <span v-if="row4.item.shipment_type == 'Air'"
                      >Gross Wgt(Kg) : {{ row4.item.lclGrossWgt }}<br
                    /></span>
                    <span v-if="row4.item.shipment_type == 'Air'"
                      >Net Wt ( in KG) : {{ row4.item.lclNetWgt }}<br
                    /></span>
                  </template>
                  <template slot="ParticularType" slot-scope="row5">
                    <span v-if="row5.item.ParticularType"
                      >Particular Type : {{ row5.item.ParticularType }}<br
                    /></span>
                    <span v-if="row5.item.ledger"
                      >Particular : {{ row5.item.ledger }}</span
                    >
                  </template>
                  <template slot="validityDate" slot-scope="row5">
                    <span v-if="row5.item.validityDate"
                      >Validity Date : {{ row5.item.validityDate }}<br
                    /></span>
                    <span v-if="row5.item.quotationTill"
                      >Rate Till : {{ row5.item.quotationTill }}<br
                    /></span>
                    <span v-if="row5.item.quotation_remark"
                      >Price Remark : {{ row5.item.quotation_remark }}<br
                    /></span>
                  </template>

                  <template slot="is_active" slot-scope="row3">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row3.item.price_id">
                      <md-switch
                        :id="'approval' + row3.item.price_id"
                        name="approval"
                        class="md-primary"
                        :value="row3.item.is_active == 1 ? true : false"
                        @change="activateUser(row3.item)"
                      >
                        <h6>
                          <br />
                          <b-badge
                            :variant="row3.item.is_active == 1 ? 'success' : 'danger'"
                            >{{
                              row3.item.is_active == 1 ? "Active" : "In-Active"
                            }}</b-badge
                          >
                        </h6>
                      </md-switch>
                    </div>
                    <!-- <h6>
                      <b-badge
                        :variant="row3.item.is_active == 1 ? 'success' : 'danger'"
                        >{{ row3.item.is_active == 1 ? "Active" : "In-Active" }}</b-badge
                      >
                    </h6> -->
                  </template>
                  <template slot="created_at" slot-scope="row3">
                    <span v-if="row3.item.created_at">
                      Created : {{ row3.item.created_at }}
                      <br />
                    </span>
                    <span v-if="row3.item.createdBy">
                      Created By : {{ row3.item.createdBy }}
                      <br />
                    </span>
                    <span v-if="row3.item.updated_at">
                      Updated : {{ row3.item.updated_at }}
                      <br />
                    </span>
                    <span v-if="row3.item.updatedBy">
                      Updated By : {{ row3.item.updatedBy }}
                      <br />
                    </span>
                  </template>

                  <!-- <template slot="action" slot-scope="row2">
                    <b-button
                      variant="outline-primary"
                      style="font-size: 0.675rem"
                      @click="editEnqPricing(row2.item)"
                      id="addButtonLoader"
                      size="sm"
                      >Update</b-button
                    >

                    <b-button
                      variant="outline-primary"
                      style="font-size: 0.675rem"
                      @click="editPricing(row2.item)"
                      id="addButtonLoader"
                      size="sm"
                      >Pricing</b-button
                    >
                  </template> -->
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="25"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-card-body>
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { globalPermissionStatus } from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import DateRangePicker from "vue2-daterange-picker";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    this.getCurrentLastDate();
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
      // Air Section Start
      this.$store.dispatch(
        "common/setAllAirLineList",
        JSON.stringify({
          itemCode: "AirLineList",
        })
      );
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList"
        })
      );
      this.$store.dispatch(
        "common/setAllAirPortDepartureList",
        JSON.stringify({
          itemCode: "AirPortDepartureList",
        })
      );
      this.$store.dispatch(
        "common/setAllAirPortDestinationList",
        JSON.stringify({
          itemCode: "AirPortDestinationList",
        })
      );
      // Air Section End

      // Sea Section Start
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );

      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({
          itemCode: "PORList",
        })
      );
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({
          itemCode: "PODList",
           type:'Normal',
        Territory:'',
        })
      );
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({
          itemCode: "LocationDetailsFinalList",
        })
      );
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({
          itemCode: "POLList",
        })
      );
      // Sea Section End

      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );
      // alert(globalPermissionStatus("Lead"))
      if (globalPermissionStatus("Enq. For Pricing")) {
        // this.$store.dispatch("setCurrentRoute", "/lead/EnqPricingList");
        this.$store.dispatch("setCurrentRoute", "/enqPrice/enqPriceList");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getData();
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export",
      adminToggle: this.$sessionsStorage.get("designation"),
      isLoading: false,
      fields: [
        {
          key: "price_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "enq_no",
          label: "Enquiry Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ShippingLine",
          label: "Shipping/Air Line",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "POD",
          label: "Location Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "currencyCode",
          label: "Others Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ParticularType",
          label: "Particulars",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "validityDate",
          label: "Rate Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_at",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //   key: "action",
        //   label: "Actions",
        //   sortable: true,
        //   sortDirection: "desc",
        // },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      Filter: {
        common: "",
        branchfilter: "",
        createdByFilter: "",
        updatedByFilter: "",
        StatusType: "",
        shipment_type: "",
        clientIdFilter: "",
        ContainerTypeFilter: "",
        startTime: "",
        endTime: "",
        fk_pod_id: "",
        fk_por_id: "",
        fk_pol_id: "",
        fk_fpod_id: "",
        fk_pre_shipping: "",
        fk_shipping_id: "",
        fk_airline_id: "",
        pendingStatus: "2",
        hours: "2",
      },
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      validate: true,
      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      moduelTypeList: [
        {
          text: "Export",
          value: "Export",
        },
        {
          text: "Import",
          value: "Import",
        },
      ],
      jobTypeList: [
        {
          text: "FF",
          value: "FF",
        },
        {
          text: "CC",
          value: "CC",
        },
        {
          text: "TPT",
          value: "TPT",
        },
      ],
      PricingQuotList: [],
      StatusTypeList: [
        {
          type: "Yes",
          val: "Yes",
        },
        {
          type: "No",
          val: "No",
        },
      ],

      pendingStatusList: [
        {
          val: "2",
          type: "Pending",
        },
        {
          val: "1",
          type: "Responded",
        },
        {
          val: "3",
          type: "All",
        },
      ],

      hoursStatusList: [
        {
          val: "1",
          type: "Between 3 Hours",
        },
        {
          val: "2",
          type: "Today",
        },
        {
          val: "3",
          type: "All",
        },
      ],

      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    MultiSelect,
    DateRangePicker,
    CustomLoader,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    activateUser(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.is_active = this.itemObj.is_active == 1 ? 0 : 1;
      let paylod = {
        tableName: "master_pricing_qutation",
        tableId: "price_id",
        tableIsActive: "is_active",
        value1: this.itemObj.is_active,
        tableVal: item.price_id,
        isMailSend:'No',
        manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    getTimeHours() {
      var myTime = new Date();
      // Create a new Date object for 3 hours ago
      var threeHoursAgo = new Date(myTime.getTime() - 3 * 60 * 60 * 1000);

      // Format the threeHoursAgo variable to display the time in a specific format
      var formattedTime =
        moment(threeHoursAgo).format("YYYY-MM-DD") +
        " " +
        threeHoursAgo.toLocaleTimeString();
      //$.datepicker.formatDate("yy-mm-dd", threeHoursAgo) +
      //" " +
      //threeHoursAgo.toLocaleTimeString();
      var currentTime = myTime;
      // this.Filter.startTime = "10:20";
      let startTime = threeHoursAgo.toLocaleTimeString().split(":");
      let endTime = currentTime.toLocaleTimeString().split(":");

      if (this.Filter.hours == "1") {
        this.Filter.startTime = (
          (startTime[0].length == 1 ? "0" + startTime[0] : startTime[0]) +
          ":" +
          (startTime[1].length == 1 ? "0" + startTime[1] : startTime[1])
        ).toString();
        this.Filter.endTime = (
          (endTime[0].length == 1 ? "0" + endTime[0] : endTime[0]) +
          ":" +
          (endTime[1].length == 1 ? "0" + endTime[1] : endTime[1])
        ).toString();
      } else if (this.Filter.hours == "2") {
        this.Filter.startTime = "00:01";
        this.Filter.endTime = "23:59";
      } else {
        this.Filter.startTime = "";
        this.Filter.endTime = "";
        this.getCurrentLastDate();
      }
      console.log("this.Filter=>", this.Filter);
      console.log("endTime=>", endTime);
      console.log("startTime=>", startTime);
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay1 = "";
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay1 = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + lastDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      //  alert(firstDay);
      // alert(lastDay);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01

      if (this.Filter.hours == "3") {
        this.startDate = firstDay1;
        this.dateRange = {
          startDate: firstDay1,
          endDate: lastDay,
        };
      } else {
        this.startDate = today;
        this.dateRange = {
          startDate: today,
          endDate: today,
        };
      }

      // alert(today);
      this.getTimeHours();
    },
    wordWrap,
    goBack() {
      window.history.go(-1);
    },

    AddLeadTrack(item) {
      this.$sessionsStorage.set("edit_price_id", item.price_id);
      this.$router.push({
        path: "/lead/leadTrack",
      });
    },
    editEnqPricing(item) {
      console.log("Item=>", item);
      this.$sessionsStorage.set("edit_price_id", item.price_id);
      this.$router.push({
        path: "/pricing/upsertEnqPrice",
      });
    },
    editPricing(item) {
      console.log("Item=>", item);
      this.$sessionsStorage.set("edit_enq_price_id", item.enq_price_id);
      this.$router.push({
        path: "/pricing/upsertPrice",
      });
    },
    AddLead() {
      this.$sessionsStorage.set("edit_price_id", "");
      this.$router.push({
        path: "/pricing/upsertEnqPrice",
      });
    },
    getReports(id, btnName) {
      let payload = {
        excelId: id,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
        // alert(ExcelName)
        // if (ExcelName) {
        //   window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + ExcelName;
        // }
      }
    },
    activateLeadMaster() {
      if (this.LeadMaster.is_active == 1 || this.LeadMaster.is_active == true) {
        this.LeadMaster.is_active = false;
      } else if (this.LeadMaster.is_active == 0 || this.LeadMaster.is_active == false) {
        this.LeadMaster.is_active = true;
      }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getData();
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.Filter = {
        common: "",
        branchfilter: "",
        createdByFilter: "",
        updatedByFilter: "",
        StatusType: "",
        shipment_type: "",
        clientIdFilter: "",
        ContainerTypeFilter: "",
        startTime: "",
        endTime: "",
        fk_pod_id: "",
        fk_por_id: "",
        fk_pol_id: "",
        fk_fpod_id: "",
        fk_pre_shipping: "",
        fk_shipping_id: "",
        fk_airline_id: "",
        pendingStatus: "2",
        hours: "2",
      };
      (this.dateRange = {
        startDate: "",
        endDate: "",
      }),
        this.getData();
      this.getTimeHours();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {},

    getData() {
      this.isLoading = true;
      let payload = {
        itemCode: "ALL_price_list_Quataion",
        searchVal: this.filter,
        Filter: this.Filter,
        dateRange: this.dateRange,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.PricingQuotList = data.PricingList;
            this.totalRows = data.PricingList.length;
            console.log("Pricing List Response=>", data);
          } else {
            this.PricingQuotList = [];
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Enquiry & Pricing List Error: ", error);
        });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// priceQuotationList.vue?6abce6a4